export default __webpack_public_path__ + "static/media/Group 3355.1b758d6b.png";